import { Component, Input, OnDestroy } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { Subscription } from 'rxjs'
import * as Reducers from 'src/app/store/reducers'

@Component({
	selector: 'app-acl',
	template: '<ng-content *ngIf="authorized"></ng-content>',
})
export class ACLComponent implements OnDestroy {
	@Input() roles: any[] = []
	authorized = false
	private subscription = new Subscription();

	constructor(private store: Store<any>) {
		this.subscription.add(this.store.pipe(select(Reducers.getUser)).subscribe(state => {
			this.authorized = (state.roles || []).some(role => this.roles.includes(role))
		}));
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
